<div class="flex flex-column consult__section consult__vital-sign">
  <div class="col-12 consult__section-subheading-group">
    <h3 class="col-12 inline-flex align-items-center p-0 consult__section-subheading cursor-pointer"
      (click)="expandSection = !expandSection">
      <i class="fas" [style.fontSize.px]="12" [ngClass]="{
        'fa-minus': expandSection,
        'fa-plus': !expandSection
      }"></i>
      <label class="ml-2 mb-0 cursor-pointer">{{screen.heading}}:</label>
    </h3>
  </div>

  <div class="col-12 flex flex-wrap align-items-center" *ngIf="expandSection">
    <label class="col-8 md:col-4 lg:col-3 m-0 justify-content-end"
      for="temperature_{{turn}}">{{screen.temperature}}{{readonly? ':' : ''}}</label>
    <span class="col-4 md:col-2 lg:col-1">
      <input pInputText type="number" name="temperature_{{turn}}" [(ngModel)]="header.temperature" class="m-0"
        validation [readonly]="readonly" *ngIf="!readonly" />

      <span *ngIf="readonly">{{header.temperature}}</span>
    </span>

    <label class="col-8 md:col-4 lg:col-3 m-0 justify-content-end"
      for="blood-pressure_{{turn}}">{{screen.bloodPressure}}{{readonly? ':' : ''}}</label>
    <span class="col-4 md:col-2 lg:col-1">
      <p-inputMask name="blood-pressure_{{turn}}" [(ngModel)]="header.bloodPressure" mask="999/99?9" class="m-0"
        validation [readonly]="readonly" *ngIf="!readonly">
      </p-inputMask>

      <span *ngIf="readonly">{{header.bloodPressure}}</span>
    </span>

    <label class="col-8 md:col-4 lg:col-3 m-0 justify-content-end" for="pulse_{{turn}}">{{screen.pulse}}{{readonly? ':'
      : ''}}</label>
    <span class="col-4 md:col-2 lg:col-1">
      <input pInputText type="number" name="pulse_{{turn}}" [(ngModel)]="header.pulse" class="m-0" validation
        [readonly]="readonly" *ngIf="!readonly" />

      <span *ngIf="readonly">{{header.pulse}}</span>
    </span>

    <label class="col-8 md:col-4 lg:col-3 m-0 justify-content-end"
      for="breathing-frequency_{{turn}}">{{screen.breathingFrequency}}{{readonly? ':' : ''}}</label>
    <span class="col-4 md:col-2 lg:col-1">
      <input pInputText type="number" name="breathing-frequency_{{turn}}" [(ngModel)]="header.breathingFrequency"
        class="m-0" validation [readonly]="readonly" *ngIf="!readonly" />

      <span *ngIf="readonly">{{header.breathingFrequency}}</span>
    </span>

    <label class="col-8 md:col-4 lg:col-3 m-0 justify-content-end" for="weight_{{turn}}">{{screen.weight}}{{readonly?
      ':' : ''}}</label>
    <span class="col-4 md:col-2 lg:col-1">
      <input pInputText type="number" name="weight_{{turn}}" [(ngModel)]="header.weight" class="m-0" validation
        [readonly]="readonly" *ngIf="!readonly" />

      <span *ngIf="readonly">{{header.weight}}</span>
    </span>

    <label class="col-8 md:col-4 lg:col-3 m-0 justify-content-end" for="height_{{turn}}">{{screen.height}}{{readonly?
      ':' : ''}}</label>
    <span class="col-4 md:col-2 lg:col-1">
      <input pInputText type="number" name="height_{{turn}}" [(ngModel)]="header.height" class="m-0" validation
        [readonly]="readonly" *ngIf="!readonly" />

      <span *ngIf="readonly">{{header.height}}</span>
    </span>

    <label class="col-8 md:col-4 lg:col-3 m-0 justify-content-end" for="glucose_{{turn}}">{{screen.glucose}}{{readonly?
      ':' : ''}}</label>
    <span class="col-4 md:col-2 lg:col-1">
      <input pInputText type="number" name="glucose_{{turn}}" [(ngModel)]="header.glucose" class="m-0" validation
        [readonly]="readonly" *ngIf="!readonly" />

      <span *ngIf="readonly">{{header.glucose}}</span>
    </span>

    <label class="col-8 md:col-4 lg:col-3 m-0 justify-content-end"
      for="oxygen-saturation_{{turn}}">{{screen.oxygenSaturation}}{{readonly? ':' : ''}}</label>
    <span class="col-4 md:col-2 lg:col-1">
      <input pInputText type="number" name="oxygen-saturation_{{turn}}" [(ngModel)]="header.oxygenSaturation"
        class="m-0" validation [readonly]="readonly" *ngIf="!readonly" />

      <span *ngIf="readonly">{{header.oxygenSaturation}}</span>
    </span>

    <label class="col-8 md:col-4 lg:col-3 m-0 justify-content-end"
      for="head-circunference_{{turn}}">{{screen.headCircumference}}{{readonly? ':' : ''}}</label>
    <span class="col-4 md:col-2 lg:col-1">
      <input pInputText type="number" name="head-circunference_{{turn}}" [(ngModel)]="header.headCircumference"
        class="m-0" validation [readonly]="readonly" *ngIf="!readonly" />

      <span *ngIf="readonly">{{header.headCircumference}}</span>
    </span>
  </div>
</div>